import { render, staticRenderFns } from "./four.vue?vue&type=template&id=773f8aa4&scoped=true&"
var script = {}
import style0 from "./four.vue?vue&type=style&index=0&id=773f8aa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773f8aa4",
  null
  
)

export default component.exports